"use strict";

(function() {

	const elms = document.querySelectorAll(".js-inntektsgrense");
	var main = false, polyfills = false, runtime = false;

	const runcode = () => {
		// console.log(main,polyfills,runtime)
		if (main && polyfills && runtime) {
			elms.forEach(elm => {
				elm.id = elm.id || self.crypto.randomUUID();
				elm.innerHTML = "";
				window.MiniFrontend.bootstrapAngularApp(elm.id);
			})
		}
	}

	/* don't run DOM editing code in editing mode, or else the modified elements will be stored */
	/* (or just for speeding up the editing interface where we don't need lots of the interactivity) */
	if (!document.querySelector(".isEditing") /* Experience Editor */ && !window.hasOwnProperty("scSitecore") /* Desktop */ && !window.hasOwnProperty("scEdit") /* Content Editor preview */) {

		if (elms.length) {
			loadCss("https://tjenester.husbanken.no/bostotte-kalkulator/inntektsgrense/styles.css");
			loadScript("https://tjenester.husbanken.no/bostotte-kalkulator/inntektsgrense/main.js", () => {
				main = true;
				runcode();
			});
			loadScript("https://tjenester.husbanken.no/bostotte-kalkulator/inntektsgrense/polyfills.js", () => {
				polyfills = true;
				runcode();
			});
			loadScript("https://tjenester.husbanken.no/bostotte-kalkulator/inntektsgrense/runtime.js", () => {
				runtime = true;
				runcode();
			});
		}

	}

})();
